import React from "react";
import notify from "../../assets/images/Notification.png";
import Emergenytabs from "../../components/Dashboard/Emergenytabs";
import { Nav } from "react-bootstrap";
import { Link } from "react-router-dom";

const EmergencyAlerts = () => {
  return (
    <div className="container-box" style={{ minHeight: '100vh !important' }}>
      <div className="top-head d-flex flex-wrap justify-content-between align-items-center text-white">
        <h2>Alerts</h2>
        <Nav.Link as={Link} to="/notification" href="/notification">
          <div type="" className=" position-relative">
            <img src={notify} alt="" />
            <span className="position-absolute  badge-custom   rounded-circle">
              <span className="visually-hidden">New alerts</span>
            </span>
          </div>
        </Nav.Link>

      </div>
      <div className="my-job-tabs">
        <Emergenytabs />
      </div>
    </div>
  );
};

export default EmergencyAlerts;
